/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps } from 'react';

// Birthdays category tile: gradient circle + white line art like every other
// system category icon. A gift box with a two-loop bow - deliberately not a
// cake, which reads as "food" at 24px.
const SvgBirthdays = (props: SVGProps<SVGSVGElement>) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="24" cy="24" r="24" fill="url(#paint0_linear_birthdays)" />
    <g stroke="#F7F5F8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path d="M13 21.5a1.5 1.5 0 0 1 1.5-1.5h19a1.5 1.5 0 0 1 1.5 1.5V25H13v-3.5Z" />
      <path d="M14.8 25h18.4v9.5a2 2 0 0 1-2 2H16.8a2 2 0 0 1-2-2V25Z" />
      <path d="M24 20v16.5" />
      <path d="M24 20c-2.6 0-6.6-.9-6.6-3.7 0-1.8 1.3-3 3-3 2.5 0 3.6 3.4 3.6 6.7Z" />
      <path d="M24 20c2.6 0 6.6-.9 6.6-3.7 0-1.8-1.3-3-3-3-2.5 0-3.6 3.4-3.6 6.7Z" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_birthdays" x1="0" y1="0" x2="43.5" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F0609E" />
        <stop offset="1" stopColor="#A2148F" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgBirthdays;
